import { motion } from "framer-motion";
import { ArrowRight, Zap, BarChart3, Shield, Users, Sparkles, Crown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import Seo from "@/components/Seo";

export const FeaturesPage = () => {
  const features = [
    {
      icon: Zap,
      title: "Leveling System",
      description: "XP system con rank cards, leaderboards e role rewards",
    },
    {
      icon: BarChart3,
      title: "Analytics & Logging",
      description: "Track tutti gli eventi del server con dashboard completo",
    },
    {
      icon: Shield,
      title: "Advanced Moderation",
      description: "Automod, warns system e protections anti-raid",
    },
    {
      icon: Users,
      title: "Community Management",
      description: "Welcome messages, role assignment, reaction roles e altro",
    },
    {
      icon: Sparkles,
      title: "Fun & Engagement",
      description: "Giveaways, games e social alerts",
    },
    {
      icon: Crown,
      title: "Premium Features",
      description: "AI integration, ticket system, advanced automations",
    },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-background to-muted/30">
      <Seo
        title="Best Bot for Discord Features: Anti-Raid, Welcome, Bulk Roles, Automations"
        description="Explore NATIBOT features built for Discord servers: anti-raid, AutoMod, welcome messages, bulk roles, reaction roles, analytics, AI and automations from a best Discord bot platform."
        keywords={[
          "best bot for discord",
          "best discord bot features",
          "best discord bot for servers",
          "discord bot features",
          "anti raid discord",
          "welcome messages discord bot",
          "bulk roles discord",
          "discord automations",
          "discord analytics bot",
          "ai discord bot",
        ]}
        path="/features"
      />
      {/* Header */}
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        className="container mx-auto max-w-6xl px-6 py-12"
      >
        <Link to="/" className="inline-block mb-6">
          <Button variant="outline" className="gap-2">
            <ArrowRight className="w-4 h-4 rotate-180" />
            Back Home
          </Button>
        </Link>
        <h1 className="text-4xl md:text-5xl font-bold mb-4">Features</h1>
        <p className="text-xl text-muted-foreground max-w-2xl">
          Scopri tutte le incredible funzionalità che NATIBOT offre
        </p>
      </motion.div>

      {/* Features Grid */}
      <div className="container mx-auto max-w-6xl px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, idx) => {
            const Icon = feature.icon;
            return (
              <motion.div
                key={idx}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: idx * 0.1 }}
                className="glass-card p-6 rounded-xl hover:border-primary/50 transition-colors"
              >
                <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center mb-4">
                  <Icon className="w-6 h-6 text-primary" />
                </div>
                <h3 className="text-lg font-semibold mb-2">{feature.title}</h3>
                <p className="text-muted-foreground text-sm">{feature.description}</p>
              </motion.div>
            );
          })}
        </div>
      </div>

      {/* CTA */}
      <div className="container mx-auto max-w-6xl px-6 py-12 text-center">
        <h2 className="text-3xl font-bold mb-4">Pronto a Iniziare?</h2>
        <Link to="/dashboard">
          <Button size="lg" className="gap-2">
            Vai al Dashboard
            <ArrowRight className="w-4 h-4" />
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default FeaturesPage;
